"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeName = function (name) {
    return name
        .toLowerCase()
        .replace(/(\W+|_)/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '') || '';
};
//# sourceMappingURL=normalizeName.js.map